import React from 'react';
import { useColorModeValue } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { coreUtils } from 'src/common';
import isNil from 'lodash/isNil';
import { Colors } from 'src/shared';
import Label from './Label';

const RarityLabel = (props: { rarity: number; [key: string]: any }) => {
  const { t } = useTranslation();

  const { rarity, ...remainingProps } = props;
  const attributes = coreUtils.getAttributesByRarity(rarity);
  const bg = useColorModeValue(attributes?.light, attributes?.dark);
  const color = useColorModeValue(Colors.light.whiteText, Colors.dark.whiteText);

  if (isNil(attributes)) return null;
  return (
    <Label
      color={color}
      bg={bg}
      label={t(attributes?.label)}
      minWidth="50px"
      rounded={4}
      {...remainingProps}
    />
  );
};

export default RarityLabel;
